export const IMAGE_SLOT_PROFILES = {
  compact: {
    key: 'compact',
    widths: [480, 960],
    outputFormat: 'image/webp',
    recommendation: 'Optimized WebP · 480 / 960 px',
  },
  standard: {
    key: 'standard',
    widths: [800, 1600],
    outputFormat: 'image/webp',
    recommendation: 'Optimized WebP · 800 / 1600 px',
  },
  wide: {
    key: 'wide',
    widths: [1200, 2400],
    outputFormat: 'image/webp',
    recommendation: 'Optimized WebP · 1200 / 2400 px',
  },
} as const;

export type ImageSlotProfileKey = keyof typeof IMAGE_SLOT_PROFILES;
export type ImageSlotProfile = (typeof IMAGE_SLOT_PROFILES)[ImageSlotProfileKey];

export const IMAGE_CROP_PROFILES = {
  'portrait-2-3': { key: 'portrait-2-3', width: 2, height: 3, label: 'Portrait 2:3' },
  'portrait-3-4': { key: 'portrait-3-4', width: 3, height: 4, label: 'Portrait 3:4' },
  'portrait-4-5': { key: 'portrait-4-5', width: 4, height: 5, label: 'Portrait 4:5' },
  'portrait-5-7': { key: 'portrait-5-7', width: 5, height: 7, label: 'Portrait 5:7' },
  'landscape-4-3': { key: 'landscape-4-3', width: 4, height: 3, label: 'Landscape 4:3' },
  'landscape-3-2': { key: 'landscape-3-2', width: 3, height: 2, label: 'Landscape 3:2' },
  'landscape-16-9': { key: 'landscape-16-9', width: 16, height: 9, label: 'Landscape 16:9' },
  social: { key: 'social', width: 1200, height: 630, label: 'Social 1.91:1' },
  square: { key: 'square', width: 1, height: 1, label: 'Square 1:1' },
} as const;

export type ImageCropProfileKey = keyof typeof IMAGE_CROP_PROFILES;
export type ImageCropProfile = (typeof IMAGE_CROP_PROFILES)[ImageCropProfileKey];

export function imageSlotProfile(key: ImageSlotProfileKey): ImageSlotProfile {
  return IMAGE_SLOT_PROFILES[key];
}

export function imageCropProfile(key: ImageCropProfileKey): ImageCropProfile {
  return IMAGE_CROP_PROFILES[key];
}
